import React from 'react';
import './PLMNSelection.css';

const PLMNSelection = () => {
  return (
    <div className="plmn-container">
      <h1>AT+COPS - PLMN Selection</h1>
      
      <section className="intro">
        <p>
          AT+COPS AT command forces the mobile terminal to select and register 
          the GSM/UMTS/EPS network.
        </p>
      </section>

      <section className="modes">
        <h2>Possible Values for Mode</h2>
        <ul>
          <li><strong>0</strong> - automatic (<code>&lt;oper&gt;</code> field is ignored)</li>
          <li><strong>1</strong> - manual (<code>&lt;oper&gt;</code> field shall be present, and <code>&lt;AcT&gt;</code> optionally)</li>
          <li><strong>2</strong> - deregister from network</li>
          <li>
            <strong>3</strong> - set only <code>&lt;format&gt;</code> (for read command +COPS?), 
            do not attempt registration/deregistration (<code>&lt;oper&gt;</code> and <code>&lt;AcT&gt;</code> fields are ignored); 
            this value is not applicable in read command response
          </li>
          <li>
            <strong>4</strong> - manual/automatic (<code>&lt;oper&gt;</code> field shall be present); 
            if manual selection fails, automatic mode (0) is entered
          </li>
        </ul>
      </section>

      <section className="access-tech">
        <h2>Possible Values for Access Technology</h2>
        <ul>
          <li><strong>0</strong> - GSM</li>
          <li><strong>1</strong> - GSM Compact</li>
          <li><strong>2</strong> - UTRAN</li>
          <li><strong>3</strong> - GSM w/EGPRS</li>
          <li><strong>4</strong> - UTRAN w/HSDPA</li>
          <li><strong>5</strong> - UTRAN w/HSUPA</li>
          <li><strong>6</strong> - UTRAN w/HSDPA and HSUPA</li>
          <li><strong>7</strong> - E-UTRAN</li>
        </ul>
      </section>

      <section className="examples">
        <h2>Examples</h2>
        
        <div className="example">
          <h3>Find Available Networks</h3>
          <p>
            With the Online AT Command Tester tool, you can find available networks 
            and select the network to connect. After pressing the "Find Networks" button, 
            the tester sends the <code>AT+COPS=?</code> command to initiate a network scan.
          </p>
        </div>

        <div className="example">
          <h3>Check Current Network</h3>
          <pre><code>
AT+COPS?
+COPS: 0,0,"AT&T"
OK
          </code></pre>
          <p>In this case, network selection is set to automatic (0) and the device is currently on the "AT&T" network.</p>
        </div>

        <div className="example">
          <h3>Get List of Available Operators</h3>
          <pre><code>
AT+COPS=?
+COPS: (2,"AT&T","AT&T","310410"),,(0,1,4),(0,1,2)
OK
          </code></pre>
          <p>In this example, the mode is set to automatic (1) and the operator is selected.</p>
        </div>
      </section>

      <section className="related-commands">
        <h2>Related AT Commands</h2>
        <ul>
          <li>AT+CREG - Network Registration</li>
          <li>AT+CDGCONT - PDP Define</li>
          <li>AT+CGACT - PDP Activate</li>
          <li>AT+CFUN - Phone Function</li>
          <li>AT+CPIN - SIM Status</li>
          <li>AT+CIMI - Get IMSI</li>
          <li>AT+CMGS - SMS Send</li>
          <li>AT+CMGF - SMS Read</li>
          <li>AT+CMEE - Error Reporting</li>
          <li>AT+CUSD - USSD</li>
          <li>AT+CPAS - Phone Activity</li>
        </ul>
      </section>
    </div>
  );
};

export default PLMNSelection;
